import React, { useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Box } from "@sainsburys-tech/fable";
import formatSensorValue from "../../model/sensors/formatSensorValue";
import LastUpdate from "../LastUpdate";
import DeviceTagList from "../DeviceTagList";
import moment from "moment";
import { Event } from "../Tracking";

const PrimarySensorLatestValue = props => {
  return (
    <div style={{ marginTop: "4px" }}>
      <h2 className="fable:m-0">
        {formatSensorValue(
          props.lastValue ? props.lastValue.value : null,
          props.device.primarySensor.unit.description
        )}
      </h2>
      <div className="fable:mt-4 cb-c-device-list-item__time">
        {props.lastValue.time ? (
          <span>
            Last updated <LastUpdate>{props.lastValue.time}</LastUpdate>
          </span>
        ) : (
          "Awaiting value..."
        )}
      </div>
    </div>
  );
};

const DeviceListItem = props => {
  const primarySensor = props.device.primarySensor;
  const [hovered, setHovered] = useState(false);
  return (
    <Link
      to={{ pathname: `/devices/${props.device.deviceId}` }}
      className="cb-c-device-list-item--no-underline"
      onClick={() =>
        Event("Device Selector Event", props.device.name, props.device.deviceId)
      }
    >
      <Box className="cb-c-device-list-item__card fable:block">
        <div
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
          style={{ color: hovered ? "#f06c00" : "inherit", transition: "color 0.2s ease" }}
        >
        {props.device.name}
        {props.device.primarySensor && (
          <PrimarySensorLatestValue
            lastValue={{
              value:
                primarySensor.latestSensorData != null
                  ? primarySensor.latestSensorData.value
                  : "",
              time:
                primarySensor.latestSensorData != null
                  ? moment(primarySensor.latestSensorData.time)
                  : ""
            }}
            {...props}
          />
        )}
        {props.device.tags && props.device.tags.length > 0 && (
          <div className="fable:mt-4">
            <DeviceTagList deviceTags={props.device.tags} />
          </div>
        )}
        </div>
      </Box>
    </Link>
  );
};

DeviceListItem.propTypes = {
  device: PropTypes.object
};

export default DeviceListItem;
